import { createContext } from 'react';

// Define the shape of the filter context
interface FilterContextType {
  selectedBreeds: string[];
  animalType: 'all' | 'dog' | 'cat';
  pubType: 'all' | 'продажа' | 'дарение' | 'случка';
  setSelectedBreeds: React.Dispatch<React.SetStateAction<string[]>>;
  setAnimalType: React.Dispatch<React.SetStateAction<'all' | 'dog' | 'cat'>>;
  setPubType: React.Dispatch<React.SetStateAction<'all' | 'продажа' | 'дарение' | 'случка'>>;
  openPopoverHandle: (isOpen: boolean) => void;
}

// Create the FilterContext
export const FilterContext = createContext<FilterContextType | undefined>(undefined);
